import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

/**
 * Allows authenticated users into the app and bounces them out of any
 * `/auth/*` route. Unauthenticated users are kept inside `/auth/*` and
 * redirected to `/auth/login` for everything else. The whitelist is a
 * prefix match so future auth routes (`/auth/forgot-password`, etc.)
 * work without touching this file. Per implementation-guidelines §10.3.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getAuthToken()?.access_token;
  const isAuthRoute = state.url.startsWith('/auth');

  if (token) {
    if (isAuthRoute) {
      router.navigate(['/']);
      return false;
    }
    return true;
  }

  if (!isAuthRoute) {
    router.navigate(['/auth/login']);
    return false;
  }

  return true;
};
